import { transformDTOV2ToReportV2 } from 'app/extensions/reports/utils/serialization';
import { CreateReportDTOV2, DraftReportDTOV2, ReportDTOV2, ReportV2 } from 'app/extensions/types';

import { reportingAPI as reportingAPIBase } from './baseAPI';

export const reportingAPI = reportingAPIBase.injectEndpoints({
  endpoints: (builder) => ({
    getReports: builder.query<ReportDTOV2[], void>({
      query: () => ({
        url: '/',
        method: 'GET',
        showErrorAlert: true,
      }),
      providesTags: ['Reports'],
    }),
    getReportsByDashboard: builder.query<ReportDTOV2[], string>({
      query: (dashboardUid) => ({
        url: `/dashboards/${dashboardUid}`,
        method: 'GET',
        showErrorAlert: true,
      }),
      providesTags: (result, error, dashboardUid) => [{ type: 'Reports', id: dashboardUid }],
    }),
    getReport: builder.query<ReportV2, number | undefined>({
      query: (reportId) => ({
        url: `/${reportId}`,
        method: 'GET',
        showErrorAlert: true,
      }),
      transformResponse: (response: ReportDTOV2) => {
        return transformDTOV2ToReportV2(response);
      },
      providesTags: (result, error, reportId) => [{ type: 'Report', id: reportId }],
    }),
    createReport: builder.mutation<void, CreateReportDTOV2>({
      query: (report) => ({
        url: '/',
        method: 'POST',
        body: report,
        showErrorAlert: true,
      }),
      invalidatesTags: (result, error, arg) => (error ? [] : ['Reports']),
    }),
    saveDraftReport: builder.mutation<void, DraftReportDTOV2>({
      query: (report) => ({
        url: '/',
        method: 'POST',
        body: report,
        showErrorAlert: true,
      }),
      invalidatesTags: (result, error, arg) => (error ? [] : ['Reports']),
    }),
    updateReport: builder.mutation<void, ReportDTOV2>({
      query: (report) => ({
        url: `/${report.id}`,
        method: 'PUT',
        body: report,
        showErrorAlert: true,
      }),
      invalidatesTags: (result, error, arg) => (error ? [] : ['Reports', { type: 'Report', id: arg.id }]),
    }),
    updateStateReport: builder.mutation<void, ReportDTOV2>({
      query: (report) => ({
        url: `/${report.id}`,
        method: 'PUT',
        body: report,
        showErrorAlert: true,
      }),
      invalidatesTags: (result, error, arg) => (error ? [] : ['Reports', { type: 'Report', id: arg.id }]),
    }),
    deleteReport: builder.mutation<void, number>({
      query: (reportId) => ({
        url: `/${reportId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, arg) => (error ? [] : ['Reports']),
    }),
    sendTestEmail: builder.mutation<void, DraftReportDTOV2>({
      query: (report) => ({
        url: '/test-email/',
        method: 'POST',
        body: report,
        showErrorAlert: true,
      }),
    }),
  }),
});

export const {
  useCreateReportMutation,
  useSaveDraftReportMutation,
  useSendTestEmailMutation,
  useGetReportsByDashboardQuery,
  useGetReportQuery,
  useUpdateReportMutation,
  useUpdateStateReportMutation,
  useDeleteReportMutation,
  useGetReportsQuery,
} = reportingAPI;
